import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import { getDDMMYYYY, getDDMMYYYYHHMMSS, getYYYYMMDD, getYYYYMMDDHHMMSS } from '../common/utils';

import Highcharts from 'highcharts';
import drilldown from 'highcharts-drilldown';
import HighchartsReact from 'highcharts-react-official';
import $ from 'jquery';
drilldown(Highcharts);
window.jQuery = $;
window.$ = $;

var redirectURL = require('../redirectURL');
var criticaldata = []
export default class LoadSummaryColumnChart extends Component {

    constructor(props) {
        super(props);
        this.state = {
            showgrid: 'display:none',
            showtransgrid: 'display:none',
            rowdata: [],
            test: "TEstng",

        }
        this.handleDrilldown = this.handleDrilldown.bind(this)
        // this.formatNumber = this.formatNumber.bind(this)
    }
    componentDidMount = async () => {

        $(".grid-" + this.props.code).hide();
        $(".grid-trans-" + this.props.code).hide();
        $(".dataLoadpagesum" + this.props.code).hide()
        $(".dataLoadpageimgsum" + this.props.code).hide()
        $(".overlay-partsum" + this.props.code).hide()
    }
    componentWillReceiveProps(newprops) {
        if (newprops.title != this.props.dept_code) {
            //console.log("newprops ",newprops);
        }

    }
    handleDrilldown = (params) => {
        console.log("Here ,", params)
    }

    // formatNumber = (value) => {
    //     if (value >= 1e9) return (value / 1e9).toFixed(1) + 'B';
    //     if (value >= 1e6) return (value / 1e6).toFixed(1) + 'M';
    //     if (value >= 1e3) return (value / 1e3).toFixed(1) + 'K';
    //     return value.toFixed(0);
    // }
    render() {
        //console.log("this.props.code) ", this.props.code)

        function formatNumber(value) {
            if (value == null || isNaN(value)) return '-';

            const abs = Math.abs(value);

            if (abs >= 1e9) return (value / 1e9).toFixed(1).replace(/\.0$/, '') + 'B';
            if (abs >= 1e6) return (value / 1e6).toFixed(1).replace(/\.0$/, '') + 'M';
            if (abs >= 1e3) return (value / 1e3).toFixed(1).replace(/\.0$/, '') + 'K';

            return value.toFixed(0);
        }
        const dStyles = {
            width: '100%',
            height: '100%'
        }
        var highchartoptions = {
            chart: {
                type: this.props.chartType,
                events: {
                    // click: (function(self) {
                    // return function() {
                    //     const point = {
                    //     x: this.x,
                    //     y: this.y
                    //     };
                    //     self.handleDrilldown(point);
                    // };
                    // })(this)

                }
            },
            title: {
                text: this.props.title,
                //align:'left'
            },
            subtitle: {
                text: ''
            },
            accessibility: {
                announceNewData: {
                    enabled: true
                }
            },
            xAxis: {
                type: 'category'
            },
            yAxis1: {
                title: {
                    text: this.props.yaxistitle
                }

            },
            yAxis: {
                type: 'logarithmic', // keep if you're using it
                title: {
                    text: this.props.yaxistitle
                },
                labels: {
                    formatter: function () {
                        return formatNumber(this.value);
                    }
                }
            },
            legend: {
                pie: {
                    enabled: true
                },
                column: {
                    enabled: false
                },
                spline: {
                    enabled: true
                },
                // enabled:false,
            },
            // point: {
            //     events:{
            //         click:function(e)
            //         {
            //             alert("test")
            //            return this.handleDrilldown(e)
            //         }
            //     }
            // },
            plotOptions: {
                column: {
                    dataLabels: {
                        enabled: false
                    },
                    stacked: false,
                    enableMouseTracking: true,
                    cropThreshold: 500,
                    showInLegend: true,
                },
                spline: {
                    dataLabels: {
                        enabled: true,
                        // format:'{point.y}'
                    },
                    showInLegend: true,
                },
                pie: {
                    dataLabels: {
                        enabled: true,
                        format: '{point.y}' + " " + '({point.name})',
                    },
                    // showInLegend: true,
                }
            },
            plotOptions: {
                column: {
                    minPointLength: 10,  // 👈 minimum height in pixels
                    dataLabels: {
                        enabled: true,
                        formatter: function () {
                            const value = this.y;

                            if (value >= 1e9) return (value / 1e9).toFixed(1) + 'B';
                            if (value >= 1e6) return (value / 1e6).toFixed(1) + 'M';
                            if (value >= 1e3) return (value / 1e3).toFixed(1) + 'K';

                            return value;
                        }
                    },
                    stacked: false,
                    enableMouseTracking: true,
                    cropThreshold: 500,
                    showInLegend: true,
                },
            },

            tooltip: {
                // headerFormat: '<span style="font-size:11px">{series.name}</span><br>',
                // pointFormat: '<span style="color:{point.color}">{point.name}</span>: <b>{point.y} {(point.unloadtext)}</b></b><br><span style="color:{point.color}">No of trips</span>: <b>{point.trips}</b>'
                formatter: function () {
                    // console.log(this.series)
                    if (this.point.showTooltip == 1) {
                        return "<span style='font-size:11px'>" + this.series.name + "</span><br>\
                            <span style='color:{point.color}'>"+ this.point.name + "</span>: <b>" + this.point.y + "</b></b><br>"
                    }
                }
            },

            series: [
                {
                    name: this.props.seriesName,
                    colorByPoint: true,
                    data: this.props.series
                },
            ],
            drilldown: this.props.drilldownseries,
            credits: false
        };
        // console.log(highchartoptions.drilldown,"drilldown");
        // console.log(this.props.series,"162")
        if (this.props.splineSeriesData != undefined) {
            highchartoptions['series'].push(this.props.splineSeriesData)
        }
        return (
            <div>

                <HighchartsReact
                    containerProps={{ style: { width: '100%', height: '100%' } }}
                    highcharts={Highcharts}
                    style={dStyles}
                    options={highchartoptions}
                    onClick={this.handleDrilldown.bind(this)}
                />
            </div>
        );
    }
}
